import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { makeHeaderRow } from '../../utils/goal_statics';
import * as staticsApi from '../../lib/api/statics';
import TaxbillStaticsHeadquarterTable from '../../components/taxbill_statics/TaxbillStaticsHeadquarterTable';

const TaxbillStaticsHeadquarterContainer = ({
  selectedYear,
  strMonth,
  endMonth,
  tableRef,
  searchDate,
  selectedGbn,
  selectPrjTyp,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [headerRows, setHeaderRows] = useState(null);

  // const onLoadData = () => {
  //   setLoading(true);
  //   const loadedHeaders = makeHeaderRow(strMonth, endMonth);
  //   const loadedData = makeGoalStaticsHeadquartData(loadedHeaders);

  //   setHeaderRows(loadedHeaders);
  //   setData(loadedData);
  //   setLoading(false);
  // };

  const onLoadData = async () => {
    setLoading(true);

    try {
      const loadedHeaders = makeHeaderRow(strMonth, endMonth);
      setHeaderRows(loadedHeaders);
      const res = await staticsApi.getHqTaxbillStatics(
        selectedYear,
        strMonth,
        endMonth,
        selectedGbn,
        selectPrjTyp,
      );

      if (res.data.list) {
        setData(res.data.list);
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (searchDate) {
      onLoadData();
    }
  }, [searchDate]);

  return (
    <TaxbillStaticsHeadquarterTable
      data={data}
      loading={loading}
      selectedGbn={selectedGbn}
      headerRows={headerRows}
      tableRef={tableRef}
    />
  );
};

export default TaxbillStaticsHeadquarterContainer;
